import { useState } from "react"
import styled from "styled-components"

import { colors, Text, TextArea } from "@minuthq/meatball-ui-react"

import { MTooltip } from "src/ui/MTooltip/MTooltip"

type EditableTextareaProps = {
  value: string
  onSave: (value: string) => void
  placeholder: string
  tooltip?: string
}

export function EditableTextarea({
  value,
  onSave,
  placeholder,
  tooltip,
}: EditableTextareaProps) {
  const [inputValue, setInputValue] = useState(value)
  const [isEditing, setIsEditing] = useState(false)

  function handleBlur() {
    setIsEditing(false)
    onSave(inputValue)
  }

  function handleContentKeyDown(e: React.KeyboardEvent<HTMLDivElement>) {
    e.preventDefault()
    if (e.key === "Enter" || e.key === "Space") {
      setIsEditing(true)
    }
  }

  function handleTextareaFocus(e: React.FocusEvent<HTMLTextAreaElement>) {
    const end = e.target.value.length

    e.target.setSelectionRange(end, end)
    e.target.scrollTo({
      top: e.target.scrollHeight,
    })
  }

  if (isEditing) {
    return (
      <TextArea
        autoFocus
        value={inputValue}
        onChange={(value) => setInputValue(value)}
        onBlur={handleBlur}
        placeholder={placeholder}
        onFocus={handleTextareaFocus}
        maxRows={50}
      />
    )
  }

  return (
    <MTooltip title={tooltip}>
      <Content
        onClick={() => setIsEditing(true)}
        onKeyDown={handleContentKeyDown}
        tabIndex={0}
      >
        {value ? value : <Text color="secondary">{placeholder}</Text>}
      </Content>
    </MTooltip>
  )
}

const Content = styled.div`
  cursor: pointer;
  border-radius: 4px;
  transition: background-color 0.1s ease;
  width: 100%;
  min-height: 24px;
  white-space: pre-wrap;
  overflow-wrap: break-word;

  &:focus {
    background-color: ${colors.neutral};
  }

  &:hover {
    background-color: ${colors.neutral};
  }
`
